var _rect, _path, _mask, _path2, _mask2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLetterIconHover = function SvgLetterIconHover(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 28.5,
    height: 28.5,
    rx: 14.25,
    stroke: "#643268",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52341 12.2H21.4765C21.6554 12.2 21.8004 12.345 21.8004 12.5239V18.0476C21.8004 18.2265 21.6554 18.3715 21.4765 18.3715H8.52341C8.34452 18.3715 8.19951 18.2265 8.19951 18.0476V12.5239C8.19951 12.345 8.34452 12.2 8.52341 12.2ZM6.99951 12.5239C6.99951 11.6823 7.68178 11 8.52341 11H21.4765C22.3181 11 23.0004 11.6823 23.0004 12.5239V18.0476C23.0004 18.8892 22.3181 19.5715 21.4765 19.5715H8.52341C7.68178 19.5715 6.99951 18.8892 6.99951 18.0476V12.5239Z",
    fill: "#643268"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_30254_94295",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99951 7.78942C9.99951 7.35343 10.3529 7 10.7889 7H19.2101C19.6461 7 19.9995 7.35343 19.9995 7.78942V12H9.99951V7.78942Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99951 7.78942C9.99951 7.35343 10.3529 7 10.7889 7H19.2101C19.6461 7 19.9995 7.35343 19.9995 7.78942V12H9.99951V7.78942Z",
    stroke: "#643268",
    strokeWidth: 2.4,
    mask: "url(#path-3-inside-1_30254_94295)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_30254_94295",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99951 22.2106C9.99951 22.6466 10.3529 23 10.7889 23H19.2101C19.6461 23 19.9995 22.6466 19.9995 22.2106V15H9.99951V22.2106Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99951 22.2106C9.99951 22.6466 10.3529 23 10.7889 23H19.2101C19.6461 23 19.9995 22.6466 19.9995 22.2106V15H9.99951V22.2106Z",
    fill: "white",
    stroke: "#643268",
    strokeWidth: 2.4,
    mask: "url(#path-4-inside-2_30254_94295)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLetterIconHover, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/letter-icon-hover.2ca7e987.svg";
export { ForwardRef as ReactComponent };